<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-item-group>
    <v-dialog ref="dialog"
              v-model="showModal"
              persistent
              width="580px">
      <v-card>
        <div>
          <v-date-picker v-model="fromDate"
                         color="kbBlue"
                         elevation="0"
                         style="border-radius: unset"
                         reactive
                         scrollable
                         :max="max">
          </v-date-picker>

          <v-date-picker v-model="toDate"
                         color="kbBlue"
                         elevation="0"
                         reactive
                         style="border-radius: unset"
                         scrollable
                         :min="min"
                         :max="maxToDate">
          </v-date-picker>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div>
            <v-btn class="mr-2"
                   color="kbBlue"
                   @click.stop="showModal = false"
                   outlined>
              {{$t('general.cancel')}}
            </v-btn>
            <v-btn color="kbBlue"
                   dark
                   :disabled="!fromDate || !toDate"
                   @click.stop="save()">
              {{$t('general.accept')}}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu style="display: inline">
      <template v-slot:activator="{on}">
        <v-btn color="white"
               text
               v-on="on"
               class="range-picker-btn">
          {{formatDate}}
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list color="kbWhite">
        <v-list-item @click="emitDateFromNumDays(7)">
          <v-list-item-title>
            7 {{$tc('general.day', 2)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(15)">
          <v-list-item-title>
            15 {{$tc('general.day', 2)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(30)">
          <v-list-item-title>
            1 {{$tc('general.month', 1)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(60)">
          <v-list-item-title>
            2 {{$tc('general.month', 2)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(90)">
          <v-list-item-title>
            3 {{$tc('general.month', 2)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(180)">
          <v-list-item-title>
            6 {{$tc('general.month', 2)}}
          </v-list-item-title>
        </v-list-item>

        <v-list-item @click="emitDateFromNumDays(365)">
          <v-list-item-title>
            1 {{$tc('general.year', 1)}}
          </v-list-item-title>
        </v-list-item>
        <!-- alldata -->
<!--        <v-list-item v-if="showAllData" @click="emitDate(undefined, undefined, undefined, true)">
          <v-list-item-title>
            {{$t('general.allTheData')}}
          </v-list-item-title>
        </v-list-item>-->
      </v-list>
    </v-menu>

    <v-btn class="range-picker-btn ml-2"
           color="white"
           value="range"
           :class="['text']"
           outlined
           @click="showModal = true">
      {{dateTimeText || $tc('general.allTheData')}}
    </v-btn>

    <v-btn icon
           small
           v-if="dateTimeText && (!value.numDays || (value.numDays && value.numDays !== defaultNumDays))"
           @click="reset()"
           style="margin: 0px 3px; padding: 0px">
      <v-icon small color="red">clear</v-icon>
    </v-btn>

    <v-btn icon
           text
           v-if="loadingAppsStatistics"
           color="primary"
           loading
           style="margin: 0px 3px; padding: 0px">
    </v-btn>
  </v-item-group>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapState({
      loadingAppsStatistics: state => state.apps.loadingAppsStatistics
    }),
    dateTimeText () {
      if (!this.fromDate && !this.toDate && !this.value.allData) return ''
      return (this.fromDate || '∞') + ' - ' + (this.toDate || '∞')
    },
    formatDate () {
      if (this.value && this.value.allData) return 'Todo'

      else if (this.value && this.value.numDays) {
        switch (this.value.numDays) {
          case 7:
            return `7 ${this.$tc('general.day', 2)}`
          case 15:
            return `15 ${this.$tc('general.day', 2)}`
          case 30:
            return `1 ${this.$tc('general.month', 1)}`
          case 60:
            return `2 ${this.$tc('general.month', 2)}`
          case 90:
            return `3 ${this.$tc('general.month', 2)}`
          case 180:
            return `6 ${this.$tc('general.month', 2)}`
          case 365:
            return `1 ${this.$tc('general.year', 1)}`
        }
      }

      return this.$t('general.range')
    }
  },
  created () {
    this.setDates(this.value)
  },
  data () {
    return {
      showDatePicker: true,
      showModal: false,
      fromDate: '',
      toDate: '',
      min: '',
      max: new Date().toISOString().substr(0, 10),
      maxToDate: new Date().toISOString().substr(0, 10),
      defaultNumDays: 30
    }
  },
  methods: {
    emitDate (fromDate, toDate, numDays, allData) {
      this.$emit('input', { fromDate, toDate, numDays, allData })
    },
    emitDateFromNumDays (numDays) {
      this.fromDate = moment().subtract(numDays, 'days').format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.emitDate(this.fromDate, this.toDate, numDays)
    },
    reset () {
      this.fromDate = ''
      this.toDate = ''
      this.emitDateFromNumDays(this.defaultNumDays)
    },
    save () {
      this.emitDate(this.fromDate, this.toDate)
      this.showModal = false
    },
    setDates (value) {
      if (value && value.numDays && (!value.fromDate || !value.toDate)) {
        this.emitDateFromNumDays(value.numDays)
        return
      }
      if (value.allData) {
        this.fromDate = ''
        this.toDate = ''
        return
      }
      if (value.fromDate && value.toDate) {
        this.fromDate = value.fromDate
        this.toDate = value.toDate
        return
      }
      this.reset()
    },
    showTimePicker () {
      this.showDatePicker = false
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    showAllData: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    fromDate (value) {
      this.min = value
    },
    toDate (value) {
      this.max = value
    },
    value (value) {
      this.setDates(value)
    }
  }
}
</script>

<style lang="scss">
.range-picker-btn {
  text-transform: none;
  display: inline !important;
  padding: 10px;
  cursor: pointer;
  margin: 0px;
  min-width: auto;
}
</style>
